import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/gitter': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M66.4 322.5h-50.4v-322.5h50.4v322.5zM166.9 76.1v435.9h-50.4v-435.9h50.4zM267.5 76.1v435.9h-50.4v-435.9h50.4zM368 76v247h-50.4v-247h50.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/gitter.js
// module id = 856
// module chunks = 0